<template>
  <v-select
    :items="options"
    background-color="white"
    append-icon
    box
    flat
    solo
    dense
    single-line
    hide-details
    height="36"
    :value="getDefaultValue"
    :multiple="selectParams.multiple || false"
    :placeholder="placeholder"
    :class="selectParams.alternate ? 'select-input select-menu-border' : 'select-menu'"
    :style="{'max-width' : selectParams.width}"
    :menu-props="{offsetY: true, maxHeight: 300, transition: false}"
    @input="$emit('update:element', $event)"
  >
    <template v-slot:item="data">
      <v-layout
        d-flex
        align-center
        justify-start
        class="text-xs-left menu-item"
        :class="{'menu-item-selected': data.tile.props.value}"
      >
        <v-flex
          v-if="selectParams.custom && data.item.value"
          class="no-margin no-padding"
        >
          {{ customOption(data.item.text) }}
        </v-flex>
        <v-flex v-else class="no-margin no-padding">
          {{ data.item.text }}
        </v-flex>
      </v-layout>
    </template>
  </v-select>
</template>

<script>
import { isEmpty } from '../../../utils/generalUtils'

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    selectParams: {
      type: Object,
      required: true
    },
    element: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      required: true
    }
  },

  computed: {
    getDefaultValue() {
      if (!isEmpty(this.element)) return this.element
      return null
    }
  },

  methods: {
    customOption(item) {
      return `${this.selectParams.prefix || ''}${this.commaSeparated(
        item
      )}${this.selectParams.suffix || ''}`
    },

    commaSeparated(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="sass">
.select-menu-border
  border: 1px solid $hwayzBlack !important
  border-radius: 0.5rem
  .v-input__control
    min-height: 10px !important
  .v-input__slot
    min-height: 10px !important
    font-size: 1.4rem
    padding: 0.7rem !important
</style>

<style lang="sass" scoped>
.menu-item
  margin: -0.5rem -1rem -0.5rem -1rem
  padding: 0.5rem 0.5rem 0.5rem 0.5rem
  border: transparent 0.2rem solid

.menu-item-selected
  border: $black 0.2rem solid !important
  color: $black

.select-input
  padding: 0.7rem
  border: 1px solid $hwayzBlack
  font-size: 1.4rem
  margin: 6px 8px !important

.select-menu-border
  margin: 6px 8px !important

.select-menu
  @media only screen and (max-width: 600px)
    height: 47px
    border-bottom: 1px solid $hwayzMediumGray
.select-menu .menu-item-selected
  @media only screen and (max-width: 600px)
    border: none!important
</style>
